import { render } from "./HomeData.vue?vue&type=template&id=19db661b&scoped=true"
import script from "./HomeData.vue?vue&type=script&lang=js"
export * from "./HomeData.vue?vue&type=script&lang=js"

import "./HomeData.vue?vue&type=style&index=0&id=19db661b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db661b"]])

export default __exports__